import{__awaiter as i,__generator as r}from"./_virtual/_tslib.js";import t from"./mixins/mixins.js";import{theSameArray as e}from"./utils/amap-helpers.js";import{defineProp as s}from"./mixins/props.js";import o,{withDepth as n}from"./mixins/district-layer.js";var m=t(o,n).extend({name:"AmapDistrictLayerProvince",amapMeta:{initComponent:function(t,e){return i(this,void 0,void 0,(function(){return r(this,(function(i){return[2,new t.DistrictLayer.Province(e)]}))}))}},props:{adcode:s({type:[Array,String,Number],deep:!0,equals:e,setter:"setDistricts"})}});export default m;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amap/amap-vue/es/district-layer-province.js
// module id = null
// module chunks = 